import { useState } from "react";
import { Avatar, Box, HStack, Image, IconButton, VStack } from "@chakra-ui/react";
import { Link } from "react-router-dom";

import Searchbar from "./Searchbar";
import { getAuthToken } from "../utilities/auth";

import { BsLayoutSidebarInsetReverse } from "react-icons/bs";

import logo from "../assets/Leaderbored_logo_HD.webp";
import loginIcon from "../assets/Nav-Icons/LBPortal_Graphic_Login.png";


const RED = 'rgb(204,76,73)'
const ORANGE = 'rgb(241,157,68)'
const GREEN = 'rgb(139,157,73)'

const COLORS = [RED, ORANGE, GREEN]


const DesktopNav = ({ isSidebarToggled, setIsSidebarToggled }) => {
  const [currentColorIdx, setCurrentColorIdx] = useState(0)
  const token = getAuthToken();

  /* const rendernavItems = navItems.map((item) => (
    <Box
      borderRadius='10px'
      _hover={{
        bgColor: "whiteAlpha.500",
      }}
      p='10px'
      as={Link}
      key={item.text}
      to={item.path}
    >
      <VStack>
        <Image maxH='24px' src={item.icon} alt='Navigation icon' />
        <Box>{item.text}</Box>
      </VStack>
    </Box>
  ));

  const renderSocials = socials.map((social) => {
    return (
      <Link target='_blank' to={social.link} key={social.link}>
        <Icon as={social.icon} boxSize={8} />
      </Link>
    );
  });
  */

  const loginNav = (
    <Box
      borderRadius='10px'
      _hover={{
        bgColor: "whiteAlpha.500",
      }}
      p='10px'
      as={Link}
      to='/auth'
    >
      <VStack>
        <Image maxH='24px' src={loginIcon} alt='Navigation icon' />
        <Box>Login</Box>
      </VStack>
    </Box>
  );

  return (
    <>
      {isSidebarToggled && <IconButton
        position='absolute'
        left='2%'
        color='white'
        size='sm'
        variant='ghost'
        _hover={{ bg: COLORS[currentColorIdx] }}
        icon={<BsLayoutSidebarInsetReverse size='16px' />}
        aria-label='Social Media'
        onClick={() => setIsSidebarToggled(!isSidebarToggled)}
        onMouseLeave={() => setCurrentColorIdx((prevIdx) => (prevIdx + 1) % COLORS.length)}
      />}

      <Link to='/'>
        <Image w='72px' src={logo} alt='Leaderbored logo' />
      </Link>
      {/* <Box boxSize={10} /> */}
      {/* {rendernavItems} */}
      <HStack gap='16px'>
        <Searchbar width={'25vw'} />
      </HStack>
      {!token && loginNav}
      {token && (
        <Link to='/account'>
          <Avatar as='button' bg='primaryLight' boxSize={10} />
        </Link>
      )}
      {/* <HStack gap='16px'>{renderSocials}</HStack> */}
    </>
  );
};

export default DesktopNav;
